import { redirect } from 'react-router';
import { publicAction } from '@/data/loaders';

export function loadAssessmentGrader({ request, params }) {
  return new Promise(function(resolve, reject) {

    publicAction("getAssessmentGrader", { assessment_id: params.assessment_id, course_id: params.course_id }).then(function({ data }) {
      if (data.value) {
        resolve({ data });
      } else if (data.student_redirect) {
        if (!params.student_uid || params.student_uid === data.uid) {
          resolve(redirect(`/courses/${params.course_id}/assessments/${params.assessment_id}/review`));
        } else {
          reject({text: "Submission not found or you don't have permission to view it", status: 404 });
        }
      } else {
        reject({text: "Assessment not found", path: `/courses/${params.course_id}`, status: 404 });
      }
    }).catch(reject);

  })
}

// In grader: assessment_id, course_id, student_uid
// In session review: session_id
// In assessment review: assessment_id, course_id
export function loadAssessmentStudentSubmission({ request, params }) {
  return new Promise(function(resolve, reject) {
    publicAction("getAssessmentStudentSubmission", { assessment_id: params.assessment_id, course_id: params.course_id, session_id: params.session_id, student_uid: params.student_uid }).then(resolve).catch((error) => {
      if (error.status == 404) {
        reject({text: "Submission not found or you don't have permission to view it", status: 404 });
      } else {
        reject(error);
      }
    });
  })
}

export function returnSubmissions({ assessment_id, course_id, student_uids }) {
  return publicAction("returnSubmissions", { assessment_id, course_id, student_uids })
}

export function updateSessionFeedback({ request, params }) {
  return new Promise(function(resolve, reject) {
    request.json().then(function(data) {

      publicAction("updateSessionFeedback", {
        feedback_data: data,
        session_id: params.session_id,
        assessment_id: params.assessment_id,
        course_id: params.course_id,
        student_uid: params.student_uid
      }).then(() => {
        resolve({success: true, data});
      }).catch(() => {
        resolve({success: false, date: Date.now()});
      });

    })
  })
}